import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX, FiPhoneCall } from 'react-icons/fi';

const navLinks = [
  "( 出租 ) 展覽板系列",
  "( 出租 ) 展示櫃系列",
  "( 租借。銷售 ) 珠寶櫃專區",
  "( 銷售 ) 展覽板系列",
  "( 銷售 ) 展示櫃系列",
  "( 銷售 ) 公佈欄系列",
  "( 銷售 ) 科板。競賽板",
  "( 銷售 ) 標示。導覽牌"
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-slate-900 shadow-lg py-2' : 'bg-slate-900/95 py-4'}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center">
          {/* Logo / Brand */}
          <div className="flex flex-col">
            <h1 className="text-xl md:text-2xl font-bold text-white tracking-wider">
              維得立/歐得立<span className="text-amber-500 text-sm md:text-base ml-2 font-normal">企業股份有限公司</span>
            </h1>
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-6">
            <a href="#contact" className="flex items-center gap-2 bg-amber-600 hover:bg-amber-500 text-white px-5 py-2 rounded-full transition-colors text-sm font-medium">
              <SafeIcon icon={FiPhoneCall} />
              聯絡我們
            </a>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden text-white p-2" onClick={() => setIsOpen(!isOpen)}>
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>

        {/* Categories Bar (Desktop) */}
        <div className="hidden lg:flex flex-wrap gap-x-6 gap-y-2 mt-4 pt-4 border-t border-slate-700/50 text-slate-300 text-xs xl:text-sm">
          {navLinks.map((link, idx) => (
            <a key={idx} href="#products" className="hover:text-amber-400 transition-colors whitespace-nowrap">
              {link}
            </a>
          ))}
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-slate-800 border-t border-slate-700 mt-2"
          >
            <div className="flex flex-col px-4 py-4 space-y-3">
              {navLinks.map((link, idx) => (
                <a key={idx} href="#products" onClick={() => setIsOpen(false)} className="text-slate-300 hover:text-amber-400 text-sm pb-2 border-b border-slate-700/50">
                  {link}
                </a>
              ))}
              <a href="#contact" onClick={() => setIsOpen(false)} className="flex items-center gap-2 text-amber-500 font-medium pt-2">
                <SafeIcon icon={FiPhoneCall} />
                聯絡我們
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}